import { eChargesType, eChargeValueType } from '@/types/Documents';
import { z } from 'zod';

export const expensesAndChargesSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  code: z.string(),
  description: z.string(),
  vatCategoryId: z.string().optional(),
  vatCategory: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
      boid: z.string(),
      isActive: z.boolean(),
      isFromManager: z.boolean(),
    })
    .optional(),
  allowValueChange: z.boolean(),
  computedOnPrimaryValue: z.boolean(),
  value: z.number(),
  chargeValueType: z.nativeEnum(eChargeValueType),
  chargeType: z.nativeEnum(eChargesType),
});

export const getExpensesAndChargesSchema = z.array(expensesAndChargesSchema);
